
interface PartnershipLevelsProps {
  onRegister: (type: 'agency' | 'strategic') => void;
}

export default function PartnershipLevels({ onRegister }: PartnershipLevelsProps) {
  return (
    <section id="partnership" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            2 Nhóm Hợp Tác Chính
          </h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-400 mx-auto mb-6 sm:mb-8"></div>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto px-4">
            Chọn hình thức hợp tác phù hợp với quy mô và mục tiêu phát triển của bạn
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
          {/* Đại lý Phổ thông */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden hover:shadow-blue-200 transition-all duration-300 transform hover:-translate-y-2">
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6 sm:p-8 text-white">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-white/20 rounded-full mb-4">
                <i className="ri-user-star-line text-3xl sm:text-4xl"></i>
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold mb-2">Đại Lý Phổ Thông</h3>
              <p className="text-blue-100 text-base sm:text-lg">Agency Partnership</p>
            </div>

            <div className="p-6 sm:p-8">
              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <i className="ri-shield-check-line text-blue-600"></i>
                  Chính Sách
                </h4>
                <ul className="space-y-2 sm:space-y-3">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Cam kết <strong>mức hoa hồng cao nhất thị trường</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700"><strong>Không ràng buộc doanh số</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Hợp tác linh hoạt theo từng đoàn</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Thỏa thuận riêng khi gửi khách đều hoặc nhiều tour liên tục</span>
                  </li>
                </ul>
              </div>

              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <i className="ri-gift-line text-blue-600"></i>
                  Quyền Lợi
                </h4>
                <ul className="space-y-2 sm:space-y-3">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Nhận <strong>full sales kit, hình ảnh, video chất lượng cao</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Nhận tài liệu training bán tour Mỹ</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Hỗ trợ chốt khách (nếu cần)</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700"><strong>Co-branding thương hiệu</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Cập nhật số chỗ, LKH sản phẩm mới mỗi tháng</span>
                  </li>
                </ul>
              </div>

              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <i className="ri-user-search-line text-blue-600"></i>
                  Ai Phù Hợp?
                </h4>
                <ul className="space-y-2 text-sm sm:text-base text-gray-700">
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-blue-600"></i>
                    Công ty du lịch, phòng vé mới
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-blue-600"></i>
                    Cộng tác viên bán tour
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-blue-600"></i>
                    HDV du lịch các thị trường
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-blue-600"></i>
                    Công ty muốn mở thêm thị trường Mỹ
                  </li>
                </ul>
              </div>

              <button 
                onClick={() => onRegister('agency')}
                className="w-full px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm sm:text-base font-bold rounded-full hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Đăng Ký Làm Đại Lý Phổ Thông
              </button>
            </div>
          </div>

          {/* Đối tác Chiến lược */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden hover:shadow-amber-200 transition-all duration-300 transform hover:-translate-y-2 border-2 border-amber-400">
            <div className="bg-gradient-to-r from-amber-500 to-amber-600 p-6 sm:p-8 text-white relative">
              <div className="absolute top-4 right-4 bg-white text-amber-600 px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold">
                PREMIUM
              </div>
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-white/20 rounded-full mb-4">
                <i className="ri-vip-crown-line text-3xl sm:text-4xl"></i>
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold mb-2">Đối Tác Chiến Lược</h3>
              <p className="text-amber-100 text-base sm:text-lg">Strategic Partnership</p>
            </div>

            <div className="p-6 sm:p-8">
              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <i className="ri-shield-star-line text-amber-600"></i>
                  Chính Sách
                </h4>
                <ul className="space-y-2 sm:space-y-3">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700"><strong>Mức lợi nhuận cao nhất hệ thống</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700"><strong>Không ràng buộc doanh số</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Thỏa thuận lợi nhuận sâu khi cùng phát triển sản phẩm</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700"><strong>Được mở hệ thống đại lý cấp dưới</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Tham gia cộng đồng phát triển sản phẩm & định hướng thị trường</span>
                  </li>
                </ul>
              </div>

              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <i className="ri-gift-2-line text-amber-600"></i>
                  Quyền Lợi
                </h4>
                <ul className="space-y-2 sm:space-y-3">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-amber-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700"><strong>Bộ công cụ marketing cao cấp</strong> (video 4K, banner premium, ảnh đoàn thực tế)</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-amber-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700"><strong>Tham gia famtrip – roadtrip khảo sát điểm đến tại Mỹ miễn phí hàng năm</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-amber-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Nhận full sales kit, hình ảnh, video chất lượng cao</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-amber-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700"><strong>Co-branding thương hiệu</strong></span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-arrow-right-s-line text-amber-600 text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-sm sm:text-base text-gray-700">Cập nhật số chỗ, LKH sản phẩm mới mỗi tháng</span>
                  </li>
                </ul>
              </div>

              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <i className="ri-user-star-line text-amber-600"></i>
                  Ai Phù Hợp?
                </h4>
                <ul className="space-y-2 text-sm sm:text-base text-gray-700">
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-amber-600"></i>
                    Công ty du lịch, phòng vé, công ty du học
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-amber-600"></i>
                    Đơn vị có khách ổn định & tăng trưởng đều
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-amber-600"></i>
                    Muốn mở mạnh thị trường Mỹ
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-amber-600"></i>
                    Muốn phát triển sản phẩm độc quyền
                  </li>
                </ul>
              </div>

              <button 
                onClick={() => onRegister('strategic')}
                className="w-full px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-white text-sm sm:text-base font-bold rounded-full hover:from-amber-600 hover:to-amber-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Trở Thành Đối Tác Chiến Lược
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}